import React from 'react';

import bannerImage from "../assets/images/intro-banner.jpg";

const Breadscrumbs = ({ title }) => {
    return (
      <div className="relative h-[50vh] w-full overflow-hidden">
          <img
            src={bannerImage}
            alt="Giới thiệu banner"
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center text-white bg-black bg-opacity-30">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-2">{title}</h1>
            <p className="text-lg md:text-xl">Trang chủ / {title}</p>
          </div>
       </div>  
    );
};

export default Breadscrumbs;
